module.exports = __webpack_public_path__ + "static/media/SimonSchädlich.b9f93a75.jpg";